import React, { useEffect, useState } from 'react';
import { Badge, Dropdown, List, Spin, Button } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import { useAuth } from '../context/AuthContext';
import API_URL from '../config/api';
import { apiFetch } from '../utils/apiFetch';

interface Notification {
  id: string;
  type: string;
  title: string;
  message: string;
  read: boolean;
  createdAt: string;
}

const NotificationBell: React.FC = () => {
  const { token } = useAuth();
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);

  const fetchNotifications = async () => {
    if (!token) return;
    setLoading(true);
    try {
      const res = await apiFetch(`${API_URL}/notifications`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (res.ok) {
        setNotifications(await res.json());
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotifications();
    // Optionally poll every 60s
    const interval = setInterval(fetchNotifications, 60000);
    return () => clearInterval(interval);
  }, [token]);

  const unreadCount = notifications.filter(n => !n.read).length;

  const markAsRead = async (id: string) => {
    await apiFetch(`${API_URL}/notifications/${id}/read`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` }
    });
    setNotifications(notifications => notifications.map(n => n.id === id ? { ...n, read: true } : n));
  };

  const notificationList = (
    <div style={{ width: 340, maxHeight: 400, overflowY: 'auto', background: '#fff', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.15)', padding: 8 }}>
      {loading ? <Spin /> : (
        <List
          dataSource={notifications}
          locale={{ emptyText: 'No notifications' }}
          renderItem={item => (
            <List.Item style={{ background: item.read ? '#fafafa' : '#e6f7ff', borderRadius: 6, marginBottom: 4 }}>
              <List.Item.Meta
                title={<span style={{ fontWeight: item.read ? 400 : 600 }}>{item.title}</span>}
                description={<span>{item.message}<br /><small>{new Date(item.createdAt).toLocaleString()}</small></span>}
              />
              {!item.read && <Button size="small" type="link" onClick={() => markAsRead(item.id)}>Mark as read</Button>}
            </List.Item>
          )}
        />
      )}
    </div>
  );

  return (
    <Dropdown
      overlay={notificationList}
      trigger={['click']}
      open={visible}
      onOpenChange={setVisible}
      placement="bottomRight"
      arrow
    >
      <Badge count={unreadCount} size="small" offset={[-2, 2]}>
        <BellOutlined style={{ fontSize: 22, cursor: 'pointer', color: unreadCount ? '#faad14' : '#888' }} />
      </Badge>
    </Dropdown>
  );
};

export default NotificationBell;
